module.exports = __webpack_public_path__ + "static/media/presentation_3.d3df7bab.svg";